import { Component, OnInit, Injector, Input, ChangeDetectionStrategy } from "@angular/core";
import { ClientSettings } from "src/model/class/client-settings";
// import { Label } from 'src/model/class/component classes/label';
import { GenericBasicGUI } from "src/model/class/component classes/generic-basic-gui";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";

@Component({
    selector: "app-label",
    templateUrl: "./label.component.html",
    styleUrls: ["./label.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

/* tslint:disable:no-string-literal */
/* tslint:disable:object-literal-key-quotes */

/**
 * Giorgia - Each supervision component is an html component which extends the corresponding Model, which (at the end)
 * extends the GenericBasicGUI that has the SupervisionComponentAPI (the object taken from the API)
 * Each level of the parenthood work on the specific informations that are associated to it.
 * We need to clean the class because someone are useless, but I still don't know which one.
 */
export class LabelComponent extends GenericBasicGUI implements OnInit {
  /*
   * Giorgia - Style object used to assign style in the html label
   */
  public styles = {
    "font-family": "Arial",
    color: "#000000",
    "font-size": "15px",
    "font-style": "normal", // italic
    "font-weight": "normal", // bol
    "text-decoration": "none", // underline
    left: "0px",
    top: "0px",
    width: "10px",
    height: "10px",
    "align-items": "center",
    "justify-content": "center",
    display: "flex",
    overflow: "hidden",
  };

  public stylesChild = {};
  public counterClick = 0;

  /**
   * Giorgia -
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if the parent classes needed some specific service I don't need to inject them here
   * but I can do the injection in the specific class.
   */
  constructor(injector: Injector) {
    super(injector);
  }

  /**
   * Giorgia - Set the first value of the text: used only as attempt to check if I can control the html code
   */
  async ngOnInit() {
    [this.styles, this.stylesChild] = super.HandleProperties(
      this.styles,
      this.stylesChild
    );

    if (!this.ShowingInDesktopVersion) {
      this.styles["height"] = "48px";
      this.styles["width"] = "inherit"; //AB: it's right just px without value in front, because we need to don't evaluate this property
      this.styles["color"] = "black";
      this.styles["font-family"] = "Arial"; //otherwise fallback in Arial

      this.subscribeSettingServiceData();

      /** Overwrite horizontal aligment style in list view component */
      this.HAlignmentList(this.hAlignment.toString());

      /** Overwrite font size in list view componet. This parameter is set on */
      if (this.currentClientSetting.supervisionFontSize) {
        this.styles["font-size"] =
          this.currentClientSetting.supervisionFontSize + "px";
      }
    } else {
      this.AssignFlexAlignment(
        this.styles,
        this.ComponentAPI.properties["HAlignment"],
        this.ComponentAPI.properties["VAlignment"]
      );
    }

    if (this.boldForced) {
      this.styles["font-weight"] = "bold";
    }
  }

  ngOnDestroy() {
    this.onDestroyChildren();
  }

  /**
   * Giorgia - Recursive function used to build the style object to assign to the component:
   * Each parent class has a getStyles function that keep the styles object, change it if necessary and return the object
   * The build of the style object is distribuited in the parent class to make each class responsible of it's informations
   * (Why? Iif we have to change a property we can change it in a single place)
   */
  getStyles() { }

  /**
   * Handle click event on label
   */
  public onClickLabel(): void {
    if (this.counterClick === 0) {
      this.counterClick = 1;

      setTimeout(() => {
        if (this.counterClick === 1) {
          this.handleSingleClickFunction();
          this.navigateToSupervision();
        }

        this.counterClick = 0;
      }, 500);
    } else {
      this.handleDoubleClickFunction();
      this.counterClick = 0;
    }
  }
}
